import { createAsyncThunk } from "@reduxjs/toolkit";

import type { NapiClient } from "@app/services/api";
import type { NapiUser } from "@app/types/napi-types";

import type { AccountReduxState } from "../../store/configure-store";

import { updateRedeemableAmounts } from "../redeemable-amounts";

interface GetRedeemableAmountsParams {
  api: NapiClient;
  user: NapiUser | null;
  user_country_code: string;
}

type ThunkConfig = {
  state: AccountReduxState;
};

export const refreshRedeemableAmounts = createAsyncThunk<
  void,
  GetRedeemableAmountsParams,
  ThunkConfig
>(
  "account/refreshRedeemableAmounts",
  async ({ api, user, user_country_code }, { dispatch }) => {
    if (!user?.id || !user_country_code) {
      return;
    }

    const redeemable_amounts = await api.getRedeemableAmounts(
      user.id,
      user_country_code
    );
    if (redeemable_amounts) {
      dispatch(updateRedeemableAmounts(redeemable_amounts));
    }
  }
);
